import { Component, HostBinding, Input } from "@angular/core";
import './v-tile.component.scss';

@Component({
    selector: 'v-tile',
    template: require('./v-tile.component.html')
})
export class VTileComponent {
    @Input() tileTitle: string;
    @Input() @HostBinding("class.left-align") icon: string;
}
